import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/messages`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    Authorization: `Bearer ${token}`,
  };
};

export const getUnreadMessagesCountByUser = async () => {
  const userItem = localStorage.getItem("userInfo");

  if (!userItem) return 0;

  let user;

  try {
    user = JSON.parse(userItem);
  } catch {
    return 0;
  }

  if (!user.userId) return 0;

  try {
    const response = await axios.get(
      `${apiUrl}/countUnreadMessageUser/${user.userId}`,
      {
        headers: getAuthHeaders(),
      }
    );

    return response.data.count;
  } catch (error) {
    console.error(
      "Erreur lors du chargement du nombre de messages non lus:",
      error
    );
    return 0;
  }
};

export const getMessagesByUser = async (userId) => {
  try {
    const response = await axios.get(`${apiUrl}/allmessages/${userId}`, {
      headers: getAuthHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des messages:", error);
    return [];
  }
};

export const getSentMessagesByUser = async (userId) => {
  try {
    const response = await axios.get(`${apiUrl}/sentmessages/${userId}`, {
      headers: getAuthHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des messages envoyés:", error);
    return [];
  }
};

export const getAllMessages = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allMessages`, {
      headers: getAuthHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement de tous les messages:", error);
    return [];
  }
};

export const sendMessage = async (messageData) => {
  try {
    const response = await axios.post(`${apiUrl}/createMessage`, messageData, {
      headers: getAuthHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'envoi du message:", error);
    throw error;
  }
};

export const sendGroupMessage = async (messageData) => {
  try {
    const response = await axios.post(
      `${apiUrl}/createGroupMessage`,
      messageData,
      {
        headers: getAuthHeaders(),
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'envoi du message groupé:", error);
    throw error;
  }
};

export const markMessageAsRead = async (messageId) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/toggleRead/${messageId}`,
      {},
      {
        headers: getAuthHeaders(),
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour du message:", error);
    throw error;
  }
};

export const markAllMessagesAsRead = async (userId) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/toggleAllRead/${userId}`,
      {},
      {
        headers: getAuthHeaders(),
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour de tous les messages:", error);
    throw error;
  }
};

export const deleteMessageById = async (messageId) => {
  try {
    const response = await axios.delete(`${apiUrl}/deleteMessage/${messageId}`, {
      headers: getAuthHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression du message:", error);
    throw error;
  }
};